import React, { ReactNode } from "react";
import { BsPeopleFill } from "react-icons/bs";
import { RoutePermittedRole } from "../shared/constants/AppConst";

export interface RouterConfigData {
  id: string;
  title: string;
  messageId: string;
  icon?: string | ReactNode;
  type: "item" | "group" | "collapse" | "divider";
  children?: RouterConfigData[];
  permittedRole?: RoutePermittedRole;
  color?: string;
  url?: string;
  exact?: boolean;
  count?: number;
}

const routesConfig: RouterConfigData[] = [
  {
    id: "app",
    title: "Sample",
    messageId: "sidebar.sample",
    type: "group",
    children: [
      {
        id: "page-1",
        title: "Page 1",
        messageId: "sidebar.sample.page1",
        type: "item",
        icon: <BsPeopleFill />,
        url: "/sample/page-1",
      },
      {
        id: "workforce",
        title: "Workforce",
        messageId: "workforce",
        type: "item",
        icon: <BsPeopleFill />,
        url: "/workforce",
      },
    ],
  },
];
export default routesConfig;
